import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
  useContext,
} from "react";
import { AgGridReact } from "ag-grid-react";
import {
  getInvPDF,
  printPDFFile,
  savePatientInvoice,
  deleteErpService,
  getInvPDFObject,
  fetchQuotationById,
} from "./ERPActions/erpActions";
import AddServiceCard from "./AddServiceCard";
import ConfirmDeleteDialog from "./ConfirmDeleteDialog";
import personDetailsService from "../../core/services/personDetailsService";
import { addMonths, isBefore, isSameDay, parseISO, isValid } from "date-fns";
import { useDispatch } from "react-redux";
import { patientActions, doctorActions } from "../../core/actions";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import {
  ERP_CURRENCY_OBJ,
  ERP_GENERATE_INVOICE_REQUEST,
  ERP_INVOICE_BILLING_STAGE,
  ERP_INVOICE_PAYMENT_MODE,
  ERP_LABEL_CANCEL,
  ERP_LABEL_CLOSE,
  ERP_LABEL_GENERATE_INVOICE,
  ERP_LABEL_MOVETOBILL,
  ERP_LABEL_NEW_INVOICE,
  ERP_LABEL_PAY_NOW,
  ERP_LABEL_PAYMENT_BACK_ICON,
  ERP_LABEL_PREVIEW_INVOICE,
  ERP_LOCATION_NAME_TO_LOCATION_ID_MAP,
  ERP_IN_PATIENT_BILLING_LOC_NAME,
  ERP_OUT_PATIENT_BILLING_LOC_NAME,
  PATIENT_VISIT_TYPE_OUT_PATIENT,
  ERP_VISIT_FIN_SUMMARY_TYPE_INV,
  ERP_INVOICE_WORKING_DATA_TYPE_VIEW_INVOICE,
  ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
  ERP_VISIT_FIN_SUMMARY_TYPE_SO,
  ERP_BILLING_TYPE_NON_SO,
  MASTER_LOCATION_DATA_LOCATION_KEY,
  ERP_BILLING_TYPE_SO,
  ERP_LABEL_PRINT_INVOICE,
  PATIENT_VISIT_TYPE,
  DEFAULT_BILLING_LOCATION_BY_VISIT_TYPE,
  MESSAGE_TYPE,
  AG_GRID_REACT_MIN_ROW_HEIGHT,
  AG_GRID_REACT_HEADER_ROW_HEIGHT,
  COMPONENT_WISE_AG_GRID_PAGINATION_SIZE,
  COMPONENT_WISE_AG_GRID_PAGINATION,
  HMS_REPORT_TEMPLATE_TYPE,
  BILLING_LOCATION_NAMES,
  HMS_NEW_INVOICE_REPORT_TYPE,
} from "../../core/constants/erpConstants";
import { useSelector } from "react-redux";
import { DataContext } from "./ERPBilling"; // Import the context from ERPServiceList
import { Document, Page } from "react-pdf";
import { Close } from "@mui/icons-material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import PercentIcon from "@mui/icons-material/Percent";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import { CreditCard, FileCopyOutlined } from "@material-ui/icons";
import { vi } from "date-fns/locale";
import { format, utcToZonedTime } from "date-fns-tz";
import { helperServices } from "../../shared/helper";
import { ValueFormatterService } from "ag-grid-community";
import ProtectedComponent from "../common/ProtectedComponent";
import { All_Component_Name, ORG_DETAILS } from "../../shared/constants";
import { generateBillHtml } from "../printConvertion/DocumentConvert";
import HeaderFooterComponent from "../printConvertion/HeaderAndFooter";
import { useOrganization } from "../../configurations/OrganizationContext";
import { Loading } from "./Loading";
import NumericCellEditor from "./NumericCellEditor";

// import { useNavigate } from 'react-router-dom';

export default function ERPInvoice(props) {
  const { searchInputRef, fromQuoteId, fromLocKey } = props;
  const lastSeededQuoteIdRef = useRef(null);
  // const navigate = useNavigate();
  const org = useOrganization();
  const dispatch = useDispatch();
  const initialServiceForm = {
    quantity: 1,
    originalAmount: 0,
    discountAmount: 0,
    editamount: 0,
    doctor: "",
  };
  const [serviceForm, setServiceForm] = useState(initialServiceForm);
  const [doctorList, setDoctorList] = useState([]);
  const [isaddDisable, setIsaddDisable] = useState(false);
  const [rowInfo, setRowInfo] = useState();
  const gridRef = useRef(null);
  const { productSelected, setProductSelected } = useContext(DataContext);
  const [patientId, setPatientId] = useState(props.patientId);
  const [visitId, setVisitId] = useState(props.visitId);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedLocationDetail, setSelectedLocationDetail] = useState(
    props.selectedLocationDetails
  );
  const [locationId, setLocationId] = useState(0);
  const [columnDefs, setColumnDefs] = useState();
  const [rowData, setRowData] = useState([]);
  const [updateInvoiceCal, setUpdateInvoiceCal] = useState(false);
  const [gridDataType, setGridDataType] = useState();
  // const [invDetails, setInvDetails] = useState();
  const [viewInvoiceDetails, setViewInvoiceDetails] = useState();
  const [showViewInvoicePage, setShowViewInvoicePage] = useState(false);
  const [viewCard, setviewCard] = useState(false);
  const [pdfData, setPdfData] = useState("");
  const [gvId, setGvId] = useState(0);
  const [totalInvAmtDisountDetails, setTotalInvAmtDisountDetails] = useState({
    discountType: "flat",
    discountValue: 0.0,
  });
  const [remarks, setRemarks] = useState("");
  const [billType, setBillType] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [pendingDelete, setPendingDelete] = useState(null);
  const patientInfo = useSelector(
    (state) => state.patientDetailsState.patientBasic
  );

  const masterLocationDetails = useSelector(
    (state) => state.erpDetailsState.masterLocationDetails
  );

  const containerStyle = useMemo(
    () => ({ width: "100%", height: "300px" }),
    []
  );
  const gridStyle = useMemo(
    () => ({ alignItems: "start", height: "100%", width: "100%" }),
    []
  );
  const [printdata, setPrintData] = useState("");
  const [triggerAction, setTriggerAction] = useState("");
  const [isDisable, setIsDisable] = useState(false);
  const [isBackgroundTransparent, setIsBackgroundTransparent] = useState(false);
  // set background colour on every row
  const rowStyle = {
    background: "white",
    display: "flex",
    justifyContent: "center",
    BorderBottom: "1px solid #D0D0D0",
  };

  let currentRowHeight;

  const updateRowHeight = (params) => {
    // get the height of the grid body - this excludes the height of the headers
    const bodyViewport = document.querySelector(".ag-body-viewport");
    if (!bodyViewport) {
      return;
    }
    const gridHeight = bodyViewport.clientHeight;
    // get the rendered rows
    const renderedRowCount = params.api.getDisplayedRowCount();
    // if the rendered rows * min height is greater than available height, just just set the height
    // to the min and let the scrollbar do its thing
    if (renderedRowCount * AG_GRID_REACT_MIN_ROW_HEIGHT >= gridHeight) {
      if (currentRowHeight !== AG_GRID_REACT_MIN_ROW_HEIGHT) {
        currentRowHeight = AG_GRID_REACT_MIN_ROW_HEIGHT;
        params.api.resetRowHeights();
      }
    } else {
      // set the height of the row to the grid height / number of rows available
      currentRowHeight = Math.floor(gridHeight / renderedRowCount);
      params.api.resetRowHeights();
    }
  };

  const autoSizeStrategy = useMemo(() => {
    return {
      type: "fitGridWidth",
    };
  }, []);

  const getRowHeight = useCallback((params) => {
    return currentRowHeight;
  }, []);

  // const onGridReady = useCallback((params) => {
  //     minRowHeight = params.api.getSizesForCurrentTheme().rowHeight;
  //     currentRowHeight = minRowHeight;
  // }, []);

  const onFirstDataRendered = useCallback(
    (params) => {
      updateRowHeight(params);
    },
    [updateRowHeight]
  );

  const onGridSizeChanged = useCallback(
    (params) => {
      updateRowHeight(params);
    },
    [updateRowHeight]
  );

  // Add defaultColDef configuration
  const defaultColDef = useMemo(() => {
    return {
      // editable: true,
      sortable: true,
      flex: 1,
      filter: true,
      resizable: true,
      floatingFilter: true,
    };
  }, []);

  const newInvoiceColumnDefs = [
    {
      headerName: "Sl No.",
      field: "slNo",
      colId: "slNo",
      flex: 0.5,
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "SL No",
    },
    {
      headerName: "Service Description",
      field: "description",
      colId: "description",
      // editable: (params) => gridDataType === ERP_VISIT_FIN_SUMMARY_TYPE_SO,
      editable: true,
      flex: 2,
      cellClassRules: {
        "editable-cell": (params) => params.colDef.editable,
      },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Service Name",
    },
   {
  headerName: "Original Charges/per unit",
  field: "updatedOriginalPrice",
  colId: "originalPrice",

  editable: true,   // ✅ now always editable

  cellClassRules: {
    "editable-cell": () => true,  // optional
  },

  cellEditor: "NumericCellEditor",
  cellEditorParams: {
    decimalDigits: 2,
    maxValue: (params) => params.data.updatedOriginalPrice,
  },

  valueFormatter: (params) =>
    params.value != null ? params.value.toFixed(2) : "0.00",

  valueSetter: (params) => {
    params.data.updatedOriginalPrice = params.newValue;
    params.data.charges = params.newValue;
    return true;
  },

  cellStyle: { textAlign: "right" },
  tooltipValueGetter: () => "Original Price/per unit", // 🔥 fixed tooltip
}

    ,
    {
      headerName: "Discounted Charges/per unit",
      field: "charges",
      colId: "charges",
      hide: true,
      // editable: true,
      editable: (params) => {
        return params.data.originalPrice === 0;
      },
      cellEditor: "NumericCellEditor", // ✅ must match name in frameworkComponents
      cellEditorParams: {
        decimalDigits: 2,
      },
      // valueFormatter: (params) => params.value.toFixed(2),
       valueFormatter: (params) => (params.value != null ? params.value.toFixed(2) : '0.00'),
      valueSetter: (params) => {
        params.data.charges = params.newValue;
        return true; // ✅ ensures grid updates
      },
      cellClassRules: {
        "editable-cell": (params) => params.data.originalPrice === 0,
      },
      cellStyle: { textAlign: "right" },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      //cellClass: ["ag-cell-center", "table-head"],
      tooltipField: "Charges",
    },
    {
  headerName: "Discount Charges/per unit",
  field: "discountCharges",
  colId: "discountCharges",

  editable: true,

  cellEditor: "NumericCellEditor",

  cellEditorParams: (params) => ({
    decimalDigits: 2,
    // maxValue: Number(params.data.updatedOriginalPrice) || 0,
  }),

  valueFormatter: (params) =>
    params.value != null ? Number(params.value).toFixed(2) : "0.00",

  valueSetter: (params) => {
    const original = Number(params.data.updatedOriginalPrice) || 0;
    let newDiscount = Number(params.newValue) || 0;

    // ✅ If discount > original → reset to 0
    if (newDiscount > original) {
      newDiscount = 0;
    }

    params.data.discountCharges = newDiscount;

    // Update charges
    params.data.charges = original - newDiscount;

    return true;
  },

  cellStyle: { textAlign: "right" },

  tooltipValueGetter: () =>
    "Discount must be less than or equal to Original Price",
}
,
    {
      headerName: "Units",
      field: "quantity",
      colId: "quantity",
      editable: true,
      flex: 0.5,
      cellEditor: "NumericCellEditor", // ✅ must match name in frameworkComponents
      cellEditorParams: {
        decimalDigits: 0,
      },
      valueSetter: (params) => {
        params.data.quantity = params.newValue;
        return true; // ✅ ensures grid updates
      },
      cellClassRules: {
        "editable-cell": (params) => params.colDef.editable,
      },
      cellStyle: { textAlign: "right" },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Quantity",
    },
    {
      headerName: "Price",
      field: "price",
      colId: "price",
      valueGetter: "data.charges * data.quantity",
      // valueFormatter: (params) => params.value.toFixed(2),
       valueFormatter: (params) => (params.value != null ? params.value.toFixed(2) : '0.00'),
      cellStyle: { textAlign: "right" },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Total Price",
    },
    {
      headerName: "Action",
      field: "action",
      editable: false,
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      cellRenderer: "ActionRenderer",
      tooltipField: "Action",
      autoHeight: true,
    },
  ];

  const viewInvoiceColumnDefs = [
    {
      headerName: "Invoice Line Id",
      field: "invoiceLineId",
      colId: "invoiceLineId",
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "SL No",
    },
    {
      headerName: "Service Name",
      field: "productName",
      colId: "productName",
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Product Name",
    },
    {
      headerName: "Original Charges/per unit",
      field: "originalPriceSell",
      colId: "originalPrice",
      cellStyle: { textAlign: "right" },
      // valueFormatter: (params) => params.value.toFixed(2),
       valueFormatter: (params) => (params.value != null ? params.value.toFixed(2) : '0.00'),
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      //cellClass: ["ag-cell-center", "table-head"],
      tooltipField: "Original Price Inclusive of Tax",
    },
    {
      headerName: "Discount Charges/per unit",
      field: "discount",
      colId: "discount",
      valueGetter: "data.originalPriceSell - (data.unitPriceIncTax/(1+data.taxRate))",
      cellStyle: { textAlign: "right" },
      // valueFormatter: (params) => params.value.toFixed(2),
       valueFormatter: (params) => (params.value != null ? params.value.toFixed(2) : '0.00'),
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      //cellClass: ["ag-cell-center", "table-head"],
      tooltipField: "Discount Charges Inc of Tax",
    },
    {
      headerName: "Tax Rate",
      field: "taxRate",
      colId: "taxRate",
      valueGetter: "data.taxRate",
      cellStyle: { textAlign: "right" },
      // valueFormatter: (params) => params.value.toFixed(2),
       valueFormatter: (params) => (params.value != null ? params.value.toFixed(2) : '0.00'),
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      //cellClass: ["ag-cell-center", "table-head"],
      tooltipField: "TaxRate of the product",
    },
    // {
    //   headerName: "Discounted Charges/per unit",
    //   field: "unitPriceIncTax",
    //   colId: "unitPriceIncTax",
    //   cellStyle: { textAlign: "right" },
    //   valueFormatter: (params) => params.value.toFixed(2),
    //   // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
    //   //cellClass: ["ag-cell-center", "table-head"],
    //   tooltipField: "Discounted Charges Inc of Tax",
    // },
    {
      headerName: "Units",
      field: "units",
      colId: "units",
      cellStyle: { textAlign: "right" },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Quantity",
    },
    {
      headerName: "Price",
      field: "price",
      colId: "price",
      valueGetter: "data.units * data.unitPriceIncTax",
      // valueFormatter: (params) => params.value.toFixed(2),
       valueFormatter: (params) => (params.value != null ? params.value.toFixed(2) : '0.00'),
      cellStyle: { textAlign: "right" },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Total Price",
    },
    // {
    //     headerName: 'Action',
    //     field: 'action',
    //     // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
    //     cellRenderer: 'ActionRenderer',
    //     tooltipField: "Action",
    // },
  ];

  const getRowId = useCallback((params) => {
    return params.data.id;
  }, []);

  // First, add the ActionRenderer component at the top of your file
  const ActionRenderer = (cellProps) => {
    console.log("erpinvoice-actionrenderer_props: ", cellProps);
    // if(props.data){
    console.log("erpinvoice-actionrenderer_props: ", cellProps.data);
    // }
    const onDelete = async () => {
      console.log("props.data.slNo: ", cellProps.data.slNo, cellProps.rowIndex);

      // Check if the row has soId and soLinID for ERP service deletion
      if (cellProps.data.soId && cellProps.data.soLineId) {
        try {
          console.log(
            "Deleting ERP service with soId:",
            cellProps.data.soId,
            "soLinID:",
            cellProps.data.soLineId
          );
          const resCb = await deleteErpService(
            patientId,
            visitId,
            cellProps.data.soId,
            cellProps.data.soLineId
          );
          console.log("ERP service deletion response:", resCb);
        } catch (error) {
          console.error("Error deleting ERP service:", error);
          // You might want to show an error message to the user here
          return; // Exit early if deletion fails
        }
      }

      // Get all row data from the grid
      const allRowData = cellProps.api
        .getModel()
        .rowsToDisplay.map((row) => row.data);
      console.log("allrowdata: ", allRowData);

      // Filter out the row to be deleted
      const updatedRows = allRowData
        .filter((row) => row.slNo !== cellProps.data.slNo)
        .map((row, index) => ({
          ...row,
          slNo: index + 1, // Update serial numbers
        }));

      console.log("updatedRows: ", updatedRows);
      console.log("updatedProps: ", cellProps.api);

      setRowData(updatedRows);
      // Update the grid with new data
      cellProps.api.setRowData(updatedRows);
    };

    const openDeleteDialog = () => {
      setPendingDelete(() => onDelete);
      setOpenConfirm(true);
    };

    return (
      <>
        {!(
          viewInvoiceDetails &&
          viewInvoiceDetails.type === ERP_VISIT_FIN_SUMMARY_TYPE_INV
          || (cellProps.data.billNumber != null || cellProps.data.isConsolidated || cellProps.data.soId != null)
        ) && (
            <div
              title="Delete"
              style={{ color: "#a32424" }}
              onClick={openDeleteDialog}
            >
              <i className="material-icons mr-1">delete</i>
            </div>
          )}{" "}
      </>
      // <div className="action-cell">
      //     <button
      //         className="btn btn-danger btn-sm"
      //         onClick={onDelete}
      //     >
      //         Delete
      //     </button>
      // </div>
    );
  };

  useEffect(() => {
    const runEffect = async () => {
      console.log("props data: ", props);
      dispatch(
        doctorActions.getAssignedDoctor(patientInfo, (resCb) => {
          setGvId(resCb?.va?.targetid);
        })
      );
      let locationDetail = props.selectedLocationDetails;
      let patId = props.patientId;
      let vistid = props.visitId;
      setPatientId(patId);
      setVisitId(vistid);
      setSelectedLocationDetail(locationDetail);
      console.log("erpinvoice : propsrowupdate : ", props, props.rowUpdate);

      let rowInfo = props.rowUpdate;
      if (rowInfo) {
        if (rowInfo.type !== "PRODS_FOR_NEWINVOICE") {
          await updateRowData(props);
        } else {
          setServiceForm((prev) => ({
            ...prev,
            doctor:
              props.rowUpdate?.productDetail?.gvId > 0
                ? props.rowUpdate.productDetail.gvId
                : gvId,
            originalAmount: props.rowUpdate.originalPrice,
            editamount: props.rowUpdate.price,
            discountAmount: props.rowUpdate.originalPrice - props.rowUpdate.price,
          }));
          setviewCard(true);
          setRowInfo(rowInfo);
        }
      } else {
        setViewInvoiceDetails("");
        setColumnDefs(newInvoiceColumnDefs);
      }
    };
    runEffect();
  }, [props.rowUpdate]);

  useEffect(() => {
    console.log("rowData: ", rowData);
    console.log("erp invoice locationDetail: ", selectedLocationDetail);
    console.log("erp invoice masterLocationDetails: ", masterLocationDetails);
  }, [rowData, columnDefs, props.selectedLocationDetails]);

  useEffect(() => {
    console.log("props data : ", props, patientInfo);
    getDoctorsList();
  }, []);

  const seedGridFromQuote = async (quoteId) => {
    try {
      setLoading(true);
      const quoteDetail = await fetchQuotationById(quoteId);
      if (!quoteDetail) {
        if (typeof props.serverResposnes === "function") {
          props.serverResposnes("Could not find quotation details.", "warning");
        }
        return;
      }
      const lines = quoteDetail.lines || [];
      const mappedRows = lines.map((item, index) => {
        const units = Number(item.units || 1);
        const discountPerUnit = item.discount != null && Number(item.discount) > 0
          ? Number(item.discount)
          : (item.mrp != null && item.priceSell != null
              ? Math.max(0, Number(item.mrp) - Number(item.priceSell))
              : 0);
        // Prioritize mrp as the original gross charge before line discount
        const originalPrice = item.mrp != null
          ? Number(item.mrp)
          : (item.priceSell != null ? Number(item.priceSell) + discountPerUnit : Number(item.price ?? 0));
        const charges = item.priceSell != null && item.mrp != null
          ? Number(item.priceSell)
          : Math.max(0, originalPrice - discountPerUnit);

        return {
          date: Date.now(),
          slNo: index + 1,
          serviceName: item.name || item.product || "",
          description: item.name || item.product || "",
          originalPrice: originalPrice,
          updatedOriginalPrice: originalPrice,
          charges: charges,
          discountCharges: discountPerUnit,
          originalDiscountCharges: discountPerUnit,
          quantity: units,
          price: charges * units,
          taxId: item.taxId ?? null,
          taxRate: item.taxRate ?? 0,
          soId: null,
          soLineId: null,
          isKPCreditDiscountApplicable: true,
          isConsolidated: false,
          patientId: patientInfo?.id,
          visitId: patientInfo?.visit?.id,
          type: ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
          typePackage: false,
          action: "delete",
          productDetail: {
            ...item,
            taxid: item.taxId ?? null,
            taxRate: item.taxRate ?? 0,
            uomId: item.uom ?? null,
            varientId: item.variant ?? null,
            batchNo: item.batchNo ?? null,
            sizeId: item.size ?? null,
            sellPricetax: originalPrice,
            trackinventory: item.trackinventory ?? item.trackInventory ?? false,
            productId: item.product || "",
            productName: item.name || item.product || "",
            description: item.name || item.product || "",
            sellprice: originalPrice,
            amount: charges * units,
            billable: item.billable ?? true,
            soId: null,
            soLinID: null,
            patientId: patientInfo?.id,
            visitId: patientInfo?.visit?.id,
            price: originalPrice,
            serviceName: item.name || item.product || "",
          },
          prodId: item.product || "",
        };
      });

      setViewInvoiceDetails("");
      setColumnDefs(newInvoiceColumnDefs);
      setRowData(mappedRows);

      const dPerc = Number(quoteDetail.discountPerc || 0);
      const dRs = Number(quoteDetail.discountRs || 0);
      const quoteDiscType = (quoteDetail.custom2 || quoteDetail.discountType || "").toLowerCase().trim();

      if (quoteDiscType === "flat") {
        setTotalInvAmtDisountDetails({
          discountType: "flat",
          discountValue: dRs > 0 ? dRs : 0,
        });
      } else if (quoteDiscType === "percentage") {
        setTotalInvAmtDisountDetails({
          discountType: "percentage",
          discountValue: dPerc > 0 ? Number((dPerc * 100).toFixed(4)) : 0,
        });
      } else if (dRs > 0 && dPerc > 0) {
        // Fallback for legacy quotations where custom2 was not stored:
        // If dPerc is a clean percentage (e.g. 5, 10, 15), it was entered as percentage.
        // If dPerc has fractional decimals from flat discount / base, it was entered as flat.
        const percVal = dPerc * 100;
        const isCleanPerc = Math.abs(percVal - Math.round(percVal)) < 0.001;
        if (isCleanPerc) {
          setTotalInvAmtDisountDetails({
            discountType: "percentage",
            discountValue: Number(percVal.toFixed(2)),
          });
        } else {
          setTotalInvAmtDisountDetails({
            discountType: "flat",
            discountValue: dRs,
          });
        }
      } else if (dRs > 0) {
        setTotalInvAmtDisountDetails({
          discountType: "flat",
          discountValue: dRs,
        });
      } else if (dPerc > 0) {
        setTotalInvAmtDisountDetails({
          discountType: "percentage",
          discountValue: Number((dPerc * 100).toFixed(4)),
        });
      }

      const quoteRemarks = quoteDetail.narration || quoteDetail.narration1;
      setRemarks(
        quoteRemarks
          ? `${quoteRemarks} (Quotation #${quoteId})`
          : `Converted from Quotation #${quoteId}`
      );

      if (typeof props.serverResposnes === "function") {
        props.serverResposnes(`Loaded items from Quotation #${quoteId}`, "success");
      }

      // Tell the parent (ERPBilling) to clear its fromQuoteId state so that
      // this component won't re-seed if it unmounts and remounts (e.g. when
      // the user switches tabs). history.replaceState alone won't work because
      // ERPBilling reads the URL once at mount time as a constant.
      if (typeof props.clearFromQuoteId === "function") {
        props.clearFromQuoteId();
      }

    } catch (err) {
      console.error("seedGridFromQuote error:", err);
      if (typeof props.serverResposnes === "function") {
        props.serverResposnes(
          "Error loading quotation items: " + err.message,
          "error"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!fromQuoteId) return;
    if (!patientInfo || !patientInfo.id) return;
    // Do NOT seed from quote when the component is being opened to view an
    // existing invoice (e.g. user clicked "View Invoice" from Visit Financial
    // Summary after the invoice was generated). In that case props.rowUpdate
    // carries the invoice data (type === ERP_VISIT_FIN_SUMMARY_TYPE_INV) and
    // seeding would overwrite the invoice view with stale quote items.
    if (props.rowUpdate?.type === ERP_VISIT_FIN_SUMMARY_TYPE_INV) return;
    if (lastSeededQuoteIdRef.current === fromQuoteId) return;
    lastSeededQuoteIdRef.current = fromQuoteId;
    seedGridFromQuote(fromQuoteId);
  }, [fromQuoteId, patientInfo, props.rowUpdate]);

  const invoiceCalculation = (rowList, totalDiscountApplied) => {
    console.log("invoiceCalculation: ", rowList);
    let totalWDiscount = 0.0;
    let totalInvAmtWithoutDiscount = 0.0;
    let totalCustomerGrpWiseDiscountCharges = 0.0;
    let totalAmountWithDiscountEligibilityWDiscount = 0.0;
    let totalAmountWithDiscountEligibilityWODiscount = 0.0;
    let totalAmountWithoutDiscountEligibilityWDiscount = 0.0;
    let totalAmountWithoutDiscountEligibilityWODiscount = 0.0;
    if (rowList && rowList.length > 0) {
      // rowList.forEach((row) => {
      for (const row of rowList) {
        console.log("row cal: ", row);
        // row.

        console.log("org Details : ",org, "\n org constants: ",ORG_DETAILS);
        
        const discountedCharges = (row.quantity || 0) * (row.charges || 0);
        const totalWithoutDisAmount = (row.quantity || 0) * (row.updatedOriginalPrice || 0);
        totalCustomerGrpWiseDiscountCharges += (row.quantity || 0) * (row.charges || 0);

        totalWDiscount += discountedCharges;
        totalInvAmtWithoutDiscount += totalWithoutDisAmount;
        if ((row.isConsolidated || (row.isKPCreditDiscountApplicable && row.isKPCreditDiscountApplicable === true)) || (org.orgCode!==ORG_DETAILS.MNH_DETAILS.orgCode)) {
          totalAmountWithDiscountEligibilityWDiscount += discountedCharges;
          totalAmountWithDiscountEligibilityWODiscount += totalWithoutDisAmount;
        }

        if ((row.isKPCreditDiscountApplicable && row.isKPCreditDiscountApplicable === false && org.orgCode===ORG_DETAILS.MNH_DETAILS.orgCode)) {
          totalAmountWithoutDiscountEligibilityWDiscount += discountedCharges;
          totalAmountWithoutDiscountEligibilityWODiscount += totalWithoutDisAmount;
        }
        // let discountedCharges = row.quantity * row.charges;
        // let totalWithoutDisAmount = row.originalPrice == 0 ? row.quantity * row.charges :row.quantity * row.originalPrice;
        // totalWDiscount = totalWDiscount + discountedCharges;
        // totalInvAmtWithoutDiscount = totalInvAmtWithoutDiscount + totalWithoutDisAmount;
      }
      // );
    }

    let respData = {
      totalBeforeDiscount: totalInvAmtWithoutDiscount,
      customerGrpWiseDiscountCharges: totalCustomerGrpWiseDiscountCharges,
      calculatedDiscountAmount:
        // (billType && billType === ERP_LABEL_MOVETOBILL)? 
        (totalInvAmtWithoutDiscount - totalWDiscount),
      calculatedDiscountPerc: 0,
      //  : (totalInvAmtWithoutDiscount - totalWDiscount),
      totalAfterDiscount: totalWDiscount,
      totalAfterDiscountWithRoundOff: totalWDiscount,
      totalAmountWithDiscountEligibilityWDiscount: totalAmountWithDiscountEligibilityWDiscount,
      totalAmountWithDiscountEligibilityWODiscount: totalAmountWithDiscountEligibilityWODiscount,
      totalAmountWithoutDiscountEligibilityWDiscount: totalAmountWithoutDiscountEligibilityWDiscount,
      totalAmountWithoutDiscountEligibilityWODiscount: totalAmountWithoutDiscountEligibilityWODiscount,
      roundOff: 0.0,
    };

    if (totalDiscountApplied) {
      console.log("totalDiscountApplied: ", totalDiscountApplied);
      if (
        totalDiscountApplied.discountType === "percentage" &&
        totalDiscountApplied.discountValue > 0
      ) {
        respData.calculatedDiscountAmount =
          (respData.calculatedDiscountAmount) +
          (totalDiscountApplied.discountValue / 100) *
          (respData.totalAmountWithDiscountEligibilityWDiscount);
        console.log(
          "1calculatedDiscountAmount : ",
          respData,
          totalDiscountApplied
        );
        respData.totalAfterDiscount = respData.totalBeforeDiscount - respData.calculatedDiscountAmount;
        console.log(
          "2calculatedDiscountAmount : ",
          respData,
          totalDiscountApplied
        );
      } else {
        respData.calculatedDiscountAmount += parseFloat(
          totalDiscountApplied.discountValue
        );
        if (respData.totalAmountWithDiscountEligibilityWDiscount != 0 && totalDiscountApplied.discountValue != 0) {
          respData.calculatedDiscountPerc = (totalDiscountApplied.discountValue / (respData.totalAmountWithDiscountEligibilityWDiscount));
        }
        respData.totalAfterDiscount = respData.totalAfterDiscount - totalDiscountApplied.discountValue;
      }
    }
    let totalBillAmountWithRoundOff = helperServices.roundHalfUpInt(respData.totalAfterDiscount);
    console.log("totalBillAmountWithRoundOff:respdata :: ", totalBillAmountWithRoundOff, respData);
    //  if(respData.totalAfterDiscount > totalBillAmountWithRoundOff){
    //  respData.roundOff = respData.totalAfterDiscount - totalBillAmountWithRoundOff;
    // }else{
    respData.roundOff = (totalBillAmountWithRoundOff - (respData.totalAfterDiscount));//*(-1);
    // }
    respData.totalAfterDiscountWithRoundOff = totalBillAmountWithRoundOff;
    //respData.totalAfterDiscount - respData.roundOff;//*-1;
    console.log("invoice cal value : ", respData);
    return respData;
  };

  const updateRowData = async (propData) => {
    // const rowList = rowData;
    console.log("updateRowData: ", propData);

    if (propData.rowUpdate) {
      const inputData = propData.rowUpdate;
      console.log("inputData: ", inputData);
      if (ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE === inputData.type) {
        console.log("ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE: ", inputData);
        setColumnDefs(newInvoiceColumnDefs);
        await updateProdsToGrid(inputData);
      }

      if (ERP_VISIT_FIN_SUMMARY_TYPE_INV === inputData.type) {
        console.log("ERP_VISIT_FIN_SUMMARY_TYPE_INV: ", inputData);
        setColumnDefs(viewInvoiceColumnDefs);
        setViewInvoiceDetails(inputData);
        await updateInvoiceDetailsToGrid(inputData);
      }

      if (ERP_LABEL_PAYMENT_BACK_ICON === inputData.type) {
        console.log("ERP_LABEL_PAYMENT_BACK_ICON: ", inputData);
        setColumnDefs(newInvoiceColumnDefs);
        // setViewInvoiceDetails(inputData);
        let updatedData = [];
        // if(inputData.typePackage){
        //   updatedData = rowData.concat(inputData.newRowItems)
        // }
        var data = {
          discountType: "flat",
          discountValue: 0.0,
        };

        if (propData.rowUpdate.discountPerc > 0) {
          data.discountValue = propData.rowUpdate.discountPerc;
          data.discountType = "percentage";
        } else {
          data.discountValue = propData.rowUpdate.discountRs;
          data.discountType = "flat";
        }
        setTotalInvAmtDisountDetails(data);

        setRowData(inputData.newRowItems);
        // await updateInvoiceDetailsToGrid(inputData);
      }
      if (ERP_BILLING_TYPE_SO === inputData.type) {
        setBillType(ERP_BILLING_TYPE_SO);
        console.log("ERP_BILLING_TYPE_SO: ", inputData);
        setGridDataType(ERP_VISIT_FIN_SUMMARY_TYPE_SO);
        setColumnDefs(newInvoiceColumnDefs);
        setRowData(inputData.newRowItems);
      }

      if (
        ERP_VISIT_FIN_SUMMARY_TYPE_SO === inputData.type &&
        ERP_LABEL_MOVETOBILL !== inputData.dataType
      ) {
        setBillType(ERP_VISIT_FIN_SUMMARY_TYPE_SO);
        console.log("ERP_VISIT_FIN_SUMMARY_TYPE_SO: ", inputData);
        setColumnDefs(newInvoiceColumnDefs);
        await updateSODetailsToGrid(inputData);
      }
      if (ERP_LABEL_MOVETOBILL === inputData.dataType) {
        setBillType(ERP_LABEL_MOVETOBILL);
        console.log("ERP_LABEL_MOVETOBILL: ", inputData);
        setColumnDefs(newInvoiceColumnDefs);
        await updateMoveSOToBillDetailsToGrid(inputData);
      }
    }
  };

  const updateProdsToGrid = async (newRow) => {
    let newRowList = [];
    // let newRow = props.rowUpdate;
    console.log("updateProdsToGrid:props :: ", props);
    console.log("updateProdsToGrid: ", newRow);

    let existingRowData = [...rowData];
    let prodAlreadyExist = false;
    // if (existingRowData.length > 0) {
    //   await existingRowData.map((row) => {
    //     if (row.prodId == newRow.prodId) {
    //       // row.quantity = row.quantity + 1;
    //       prodAlreadyExist = true;
    //     } else {
    //       newRowList.push(row);
    //     }
    //   });
    //   if (!prodAlreadyExist) {
    //     newRowList.push(newRow);
    //   }
    // } else {
    //   newRowList.push(newRow);
    // }

    if (newRow.typePackage) {
      newRowList = [...existingRowData];
      let rowLength = existingRowData.length;
      const totalPrice = newRow.originalAmount;
      for (const uService of newRow.serviceList) {
        uService.quantity = newRow.quantity;
        if (newRow.discountAmount && totalPrice > 0) {
          const originalCharges = uService.charges || 0;
          const weight = originalCharges / totalPrice;
          const discountForThisService = weight * (newRow.discountAmount || 0);
          const newCharges = originalCharges - discountForThisService;
          uService.editamount = Number(newCharges.toFixed(2));
          uService.charges = Number(newCharges.toFixed(2));
          uService.discountCharges = Number(discountForThisService.toFixed(2));
        }
        rowLength += 1;
        uService.slNo = rowLength;
        newRowList.push(uService);
      }
    } else {
      newRow.slNo = rowData.length + 1;
      newRowList = existingRowData.concat(newRow);
    }

    setRowData(newRowList);
  };

  const updateInvoiceDetailsToGrid = async (data) => {
    console.log("updateInvoiceDetailsToGrid: ", data);
    setRowData(data.invoiceLineItems);
  };

  const updateSODetailsToGrid = async (data) => {
    console.log("updateSODetailsToGrid: ", data);
    const salesOrderItems = data.serviceDetails.salesOrderLineItems;
    let rowList = [];
    setGridDataType(ERP_VISIT_FIN_SUMMARY_TYPE_SO);

    for (const lineItem of salesOrderItems) {
      const newRow = {
        date: lineItem.salesOrderDate,
        slNo: lineItem.ticketLine,
        soId: data.serviceDetails.soId,
        serviceName: lineItem.product,
        originalPrice: lineItem.originalPrice,
        updatedOriginalPrice: lineItem.updatedOriginalPrice,
        gridDataType: ERP_VISIT_FIN_SUMMARY_TYPE_SO,
        charges: lineItem.charges,
        quantity: lineItem.units,
        price: lineItem.price * lineItem.units,
        type: ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
        productDetail: lineItem,
        prodId: lineItem.reference,
        action: "delete",
      };
      rowList.push(newRow);
    }
    setRowData(rowList);
  };

  const updateMoveSOToBillDetailsToGrid = async (data) => {
    console.log("updateMoveSOToBillDetailsToGrid: ", data);

    let rowList = [];

    // Check if dataType is MoveToBill
    if (data.dataType === ERP_LABEL_MOVETOBILL) {
      setGridDataType(ERP_VISIT_FIN_SUMMARY_TYPE_SO);
      // Iterate through keys excluding 'dataType' and 'type'
      Object.keys(data).forEach((key) => {
        if (!isNaN(key)) {
          console.log("!isNaN(key) first condition");
          const lineItem = data[key];
          const cleanedAmount =
            parseFloat(
              (lineItem.amount || "").toString().replace(/[₹,\s]/g, "")
            ) || 0;

          // Clone lineItem and clean amount in productDetail
          const cleanedProductDetail = {
            ...lineItem,
            amount: cleanedAmount,
          };

          const newRow = {
            date: "",
            slNo: lineItem.slNo,
            soLineId: lineItem.soLinID,
            soId: lineItem.soId,
            serviceName: lineItem.productName,
            description: lineItem.productName,
            originalPrice: lineItem.originalPrice / lineItem.quantity,
            discountCharges: ((lineItem.originalPrice / lineItem.quantity) - (lineItem.netAmount / lineItem.quantity)),
            updatedOriginalPrice: lineItem.updatedOriginalPrice / lineItem.quantity,
            originalDiscountCharges: lineItem.originalPrice / lineItem.quantity,
            charges: (lineItem.netAmount / lineItem.quantity),
            quantity: lineItem.quantity,
            price: lineItem.netAmount / lineItem.quantity,
            type: ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
            productDetail: cleanedProductDetail, // 👈 Cleaned here!
            prodId: lineItem.prodId,
            isConsolidated: lineItem.isConsolidated,
            isKPCreditDiscountApplicable: lineItem.isKPCreditDiscountApplicable,
            ticketId: lineItem.ticketId,
            ticketLineId: lineItem.ticketLineId,
            billNumber: lineItem.billNumber,
            action: "delete",
          };

          rowList.push(newRow);
        }
      });
    } else {
      console.log("!isNaN(key) second condition");
      // Original logic here for other dataTypes (e.g. 'serviceDetails.salesOrderLineItems')
      const salesOrderItems = data.serviceDetails?.salesOrderLineItems || [];
      for (const lineItem of salesOrderItems) {
        const newRow = {
          date: lineItem.salesOrderDate,
          slNo: lineItem.ticketLine,
          soId: data.serviceDetails.soId,
          serviceName: lineItem.product,
          charges: lineItem.charges,
          quantity: lineItem.units,
          price: lineItem.price * lineItem.units,
          type: ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
          productDetail: lineItem,
          prodId: lineItem.reference,
          action: "delete",
        };
        rowList.push(newRow);
      }
    }

    setRowData(rowList);
  };

  const clearSelectedProductsProp = () => {
    props.clearProps(false);
  };

  const closeNewInvoice = () => {
    setRowData(...[]);
    props.closeNewInvoice("2");
    setViewInvoiceDetails("");
    const discvalue = {
      discountType: "flat",
      discountValue: 0.0,
    };
    setTotalInvAmtDisountDetails(discvalue);
    setBillType("");
    clearSelectedProductsProp();
  };

  const generateInvoice = async () => {
    // rowData
    let invoiceItemList = [];
    const invDetail = await populateInvDetails();
    console.log("generateInvoice: inv detail :: ", invDetail);
    if (
      rowData &&
      rowData.length > 0 &&
      invDetail.loc !== null &&
      invDetail.loc !== undefined
    ) {
      let invoicePayments = [
        {
          total: invDetail.invoiceDetail.totalInvoiceAmount,
          name: "paperin",
          givenAmount: invDetail.invoiceDetail.totalInvoiceAmount,
        },
      ];
      invDetail.invoiceDetail.invoicePayments = invoicePayments;
      invDetail.invoiceDetail.narration = remarks;
      const invResp = await savePatientInvoice(
        invDetail.loc,
        invDetail.invoiceDetail,
        invDetail.erpCustId
      );
      if (invResp && invResp?.billNumber) {
        props?.serverResposnes?.(invResp.messageStrip, MESSAGE_TYPE.SUCCESS);
        if (ERP_LABEL_MOVETOBILL === props?.rowUpdate?.dataType) {
          const data = {
            patientId: patientId,
            visitId: visitId,
          };

          let dischargeDateTime = "";
          let formatted = "";

          if (patientInfo?.visit?.type === "InPatient") {
            dischargeDateTime = patientInfo?.visit?.dischargeDate;
            const timeZone = "Asia/Kolkata";

            // Parse and convert
            const utcDate = parseISO(dischargeDateTime);
            const localDate = utcToZonedTime(utcDate, timeZone);

            // Format to desired output
            formatted = format(localDate, "yyyy-MM-dd'T'HH:mm:ss", {
              timeZone,
            });
          }

          data["dischargeDate"] = formatted;
          data["checkType"] = "";

          dispatch(
            patientActions.erpV2moveToBill(data, (resCb) => {
              if (resCb.successMessages) {
                console.log("invResp : ", invResp);
                closeNewInvoice();
              }
            })
          );
          const discvalue = {
            discountType: "flat",
            discountValue: 0.0,
          };
          setTotalInvAmtDisountDetails(discvalue);
        } else {
          closeNewInvoice();
        }
      }

      if (invResp && invResp.error) {
        props.serverResposnes(invResp.error, MESSAGE_TYPE.ERROR);
        // setMessageStrip({ success: invResp.messageStrip });
      }
      setTotalInvAmtDisountDetails({
        discountType: "flat",
        discountValue: 0.0,
      });
    }
  };

  async function getBillingLoc() {
    let loc;
    if (fromLocKey && masterLocationDetails) {
      const locFromKey = helperServices.getFirstLocationIdByKey(
        masterLocationDetails,
        fromLocKey
      );
      if (locFromKey) return locFromKey;
    }
    const locDetail = selectedLocationDetail ?? [];

    const isOutPatient =
      patientInfo.visit.type.toLowerCase() ===
      PATIENT_VISIT_TYPE.OUTPATIENT.toLowerCase();

    const hasAllLocationKey = locDetail.some((el) => el?.locationKey === "all");

    const locConfig = helperServices.getMasterLocationConfigByRole();

    /**
     * Resolve billing location by visit type (OP / IP)
     */
    const getBillingByVisitType = () =>
      helperServices.getFirstLocationIdByKey(
        masterLocationDetails,
        isOutPatient
          ? MASTER_LOCATION_DATA_LOCATION_KEY.OP_BILLING
          : MASTER_LOCATION_DATA_LOCATION_KEY.IP_BILLING
      );

    /**
     * Resolve billing location by config
     */
    const getBillingByConfig = () => {
      if (
        !locConfig ||
        locConfig.defaultBillingLocation ===
        DEFAULT_BILLING_LOCATION_BY_VISIT_TYPE
      ) {
        return getBillingByVisitType();
      }

      return helperServices.getFirstLocationIdByKey(
        masterLocationDetails,
        locConfig.defaultBillingLocation
      );
    };

    /**
     * ------------------------
     * MAIN RESOLUTION LOGIC
     * ------------------------
     */

    // Case 1: Single selected location (and not ALL)
    if (!hasAllLocationKey && locDetail.length === 1) {
      const locationId =
        locDetail[0]?.locationDetails?.erpLocationDetails?.[0]?.locationid;

      // ✅ Missing clause handled here
      if (Array.isArray(locationId)) {
        loc = getBillingByConfig();
      } else {
        loc = locationId;
      }
    }
    // Case 2: Multiple selections OR ALL selected
    else {
      loc = getBillingByConfig();
    }

    return loc;
  }

  async function allContainSantathi(selectedLocationDetail) {
    return selectedLocationDetail.every(item =>
      typeof item?.locationKey === 'string' &&
      item.locationKey.toLowerCase().includes('santathi')
    );
  }

  async function populateInvDetails() {
    const currentDate = new Date();
    console.log("current Date: ", currentDate);

    console.log("populateInvDetails:selectedLocationDetail : ", selectedLocationDetail);
    let clientCustId = (selectedLocationDetail && selectedLocationDetail.length === 1 && selectedLocationDetail[0].locationKey !== "all" && allContainSantathi(selectedLocationDetail))
      ? selectedLocationDetail[0].clientERPCustId
      : null;

    console.log("clientCustId: ", clientCustId);

    let invoiceDetail = { ...ERP_GENERATE_INVOICE_REQUEST };
    let loc = "";
    if (rowData && rowData.length > 0) {
      invoiceDetail.kpCash = props.isKpCash; // Review after obtaining payload structure
      invoiceDetail.billNo = null;
      invoiceDetail.type =
        gridDataType === ERP_VISIT_FIN_SUMMARY_TYPE_SO
          ? ERP_BILLING_TYPE_SO
          : ERP_BILLING_TYPE_NON_SO;

      if (gridDataType === ERP_VISIT_FIN_SUMMARY_TYPE_SO) {
        invoiceDetail.invReportType = HMS_NEW_INVOICE_REPORT_TYPE.SO_INVOICE;
      } else {
        invoiceDetail.invReportType =
          HMS_NEW_INVOICE_REPORT_TYPE.INDIVIDUAL_INVOICE;
      }
      invoiceDetail.date = `${currentDate.getFullYear()}-${currentDate.getMonth()}-${currentDate.getDate()}`;
      invoiceDetail.refund = false;
      invoiceDetail.gvName = helperServices.getLoggedUserID(); //;
      invoiceDetail.patientId = patientId;
      invoiceDetail.visitId = visitId;
      invoiceDetail.invoiceLineItem = rowData;
      invoiceDetail.date = currentDate;
      invoiceDetail.erpCustId = clientCustId ? clientCustId : patientInfo.erpCustId;
      invoiceDetail.invoicePayments = "";
      invoiceDetail.newRowItems = [...rowData];
      invoiceDetail.billingStage = ERP_INVOICE_BILLING_STAGE;
      invoiceDetail.narration = remarks;
      let patientFullName = "";
      if (patientInfo.fname && patientInfo.mname && patientInfo.lname) {
        patientFullName =
          patientInfo.fname + " " + patientInfo.mname + " " + patientInfo.lname;
      } else {
        patientFullName = patientInfo.fname + " " + patientInfo.lname;
      }
      invoiceDetail.m_sCustomerName = patientFullName;
      invoiceDetail.customerId = patientInfo.erpCustId;
      invoiceDetail.billType = "SL";
      invoiceDetail.location = loc;
      invoiceDetail.salesperson = "Support";
      invoiceDetail.narration = "";
      invoiceDetail.custome1 = "";
      invoiceDetail.custome2 = "";
      invoiceDetail.custome3 = "";
      if (
        totalInvAmtDisountDetails &&
        totalInvAmtDisountDetails.discountType === "flat"
      ) {
        invoiceDetail.discountRs = `${totalInvAmtDisountDetails.discountValue}`;
        invoiceDetail.discountPerc = `${invoiceCalculationResp.calculatedDiscountPerc}`;
      }
      if (
        totalInvAmtDisountDetails &&
        totalInvAmtDisountDetails.discountType === "percentage"
      ) {
        // invoiceDetail.discountRs = `${invoiceCalculationResp.calculatedDiscountAmount}`;
        invoiceDetail.discountPerc = `${totalInvAmtDisountDetails.discountValue / 100}`;
      }
      invoiceDetail.roundOffQaulifier = "ROUND_OFF_UP_OR_DOWN";
      invoiceDetail.currencyId = ERP_CURRENCY_OBJ.id;
      invoiceDetail.m_aLines = [];
      invoiceDetail.invoicePayments = [];
      invoiceDetail.m_dDate = currentDate; //`${currentDate.getDate()}-${currentDate.getMonth()}-${currentDate.getFullYear()}`,

      let invoiceTotalAmount = 0.0;
      let invLineItemList = [];
      let invPaymentDetail = [];
      invoiceDetail.invoiceTotalAmount = (
        invoiceCalculationResp.totalAfterDiscountWithRoundOff
      ).toFixed(2);
      invoiceDetail.m_aLines = invLineItemList;
      invoiceDetail.invoicePayments = invPaymentDetail;
      invoiceDetail.totalInvoiceAmount = (
        invoiceCalculationResp.totalAfterDiscountWithRoundOff
      ).toFixed(2);
    }

    loc = await getBillingLoc();

    const invPopulateObj = {
      loc: loc,
      invoiceDetail: invoiceDetail,
      erpCustId: clientCustId,
    };
    // setInvDetails(invPopulateObj);
    return invPopulateObj;
  }

  const printInvoice = async (invDetail, actionType, templateReportType) => {
    setIsDisable(true);
    setLoading(true);
    setIsBackgroundTransparent(true);
    console.log("print inv: ", invDetail);

    console.log("print inv viewInvoiceDetails: ", viewInvoiceDetails);
    let ticketId = viewInvoiceDetails.ticketId;
    let customerId = patientInfo.erpCustId;
    let visitId = null;
    let reportType = null;
    let locationIds = null;
    const printPDF = await getInvPDFObject(
      ticketId,
      visitId,
      customerId,
      reportType,
      locationIds
    );
    // if (printPDF instanceof Blob) {
    //   const blobURL = URL.createObjectURL(printPDF);
    //   setPdfData(printPDF);
    //   const pdfWindow = window.open(blobURL, "_blank");
    // } else {
    //   const blobURL = printPDF;
    //   setPdfData(printPDF);
    //   const pdfWindow = window.open(blobURL, "_blank");
    // }
    // await printInvoicePDF(printPDF);

    // Navigate programmatically and pass state
    // navigate(`/invoice/${invoiceId}`, {
    //   state: {
    //     type: invoiceType,
    //     locationids: invoiceLocationIds,
    //   },
    // });
    // setShowViewInvoicePage(true);
    // viewInvoicePage(blobURL);

    const data = await generateBillHtml(
      printPDF.hmsInvReportDTOList,
      templateReportType,
      org?.orgCode
    );
    console.log("Generated HTML Data: ", data);

    setPrintData(data);
    setTriggerAction(actionType);
    setIsDisable(false);
    setLoading(false);
    setIsBackgroundTransparent(false);
  };

  const printInvoicePDF = async (invDetail, actionType, templateReportType) => {
    setIsDisable(true);
    setLoading(true);
    setIsBackgroundTransparent(true);
    console.log("print inv: ", invDetail);

    console.log("print inv viewInvoiceDetails: ", viewInvoiceDetails);
    let ticketId = viewInvoiceDetails.ticketId;
    let visitId = null;
    let customerId = patientInfo.erpCustId;
    let reportType = null;
    let locationIds = null;
    const printPDF = await getInvPDFObject(
      ticketId,
      visitId,
      customerId,
      reportType,
      locationIds
    );
    // const blobURL = URL.createObjectURL(printPDF);
    // Assuming 'printPDF' is the variable you want to check
    // if (printPDF instanceof Blob) {
    //   // You can proceed with creating the FormData and sending it
    //   console.log("printPDF is indeed a Blob object!");

    //   // Create FormData if using multipart/form-data
    //   const formData = new FormData();
    //   formData.append("file", printPDF, "invoice.pdf");

    //   // const arrayBuffer = await printPDF.arrayBuffer();

    //   const printResp = await printPDFFile(formData);
    //   console.log("printResp :", printResp);
    // } else {
    //   console.error("printPDF is NOT a Blob object. It is:", printPDF);
    //   // Handle the case where it's not a Blob (e.g., show an error, convert it, etc.)
    // }
    const data = await generateBillHtml(
      printPDF.hmsInvReportDTOList,
      templateReportType,
      org.orgCode
    );
    console.log("Generated HTML Data: ", data);

    setPrintData(data);
    setTriggerAction(actionType);
    setIsDisable(false);
    setLoading(false);
    setIsBackgroundTransparent(false);
  };

  const handleCloseViewInvoicePage = () => {
    setShowViewInvoicePage(false);
  };

  // function viewInvoicePage(blobUrl) {
  //   setShowViewInvoicePage(true);
  //
  //   return (
  //
  //   );
  // }
  // if(showViewInvoicePage){
  //   return (
  //   );
  // }

  const showPaymentPage = async () => {
    // setPaymentPage(true);
    const invResp = await populateInvDetails();
    console.log("invResp: ", invResp);
    props.invPaymentDetails(invResp);
    setTotalInvAmtDisountDetails({
      discountType: "flat",
      discountValue: 0.0,
    });
  };

  const handleDiscountTypeChange = (event) => {
    console.log("handleDiscountTypeChange: ", event);
    console.log("handleDiscountTypeChange1: ", event.target.value);
    // if(totalInvAmtDisountDetails.discountType==='flat'){
    let data = {
      discountType: event.target.value,
      discountValue: 0.0,
    };
    setTotalInvAmtDisountDetails(data);
    // }else {
    //   let data = {
    //     discountType: 'flat',
    //     discountValue: 0.0,
    //   }
    //   setTotalInvAmtDisountDetails(data);
    // }
  };

  const handleCancelAdd = () => {
    props.clearProps(true);
    setviewCard(false);
    setServiceForm(initialServiceForm);
    console.log("addservice after cancel", rowData);
  };

  const handleAdd = async (event) => {
    if (searchInputRef?.current) {
      searchInputRef.current.focus();
    }
    setIsaddDisable(true);
    await updateRowData({
      ...props,
      rowUpdate: {
        ...props.rowUpdate,
        ...serviceForm,
        description: rowInfo.description,
        charges: serviceForm.editamount,
        discountCharges: serviceForm.discountAmount,
        updatedOriginalPrice: serviceForm.originalAmount,
      },
    });
    setviewCard(false);
    setServiceForm(initialServiceForm);
    setIsaddDisable(false);
  };

  const getDoctorsList = (data) => {
    const doctorsDetail = personDetailsService?.getDoctorsDetail?.();

    if (!Array.isArray(doctorsDetail)) {
      setDoctorList([]);
      return;
    }

    const list = [];

    for (const doc of doctorsDetail) {
      if (!doc) continue;

      const opt = helperServices?.buildDoctorOption?.(doc);
      if (opt) {
        list.push(opt);
      }
    }

    setDoctorList(list);
  };


  const handleDiscountValueChange = (event) => {
    console.log("handleDiscountValueChange: ", event);
    console.log("data value: ", event.target.value, invoiceCalculationResp);
    let netAmountValueAfterDiscount = 0.0;
    if (totalInvAmtDisountDetails.discountType === "flat") {
      let discountedAmount =
        event.target.value === "" ? 0.0 : parseFloat(event.target.value);
      netAmountValueAfterDiscount =
        invoiceCalculationResp.totalAmountWithDiscountEligibilityWDiscount -
        discountedAmount;
    }
    console.log(
      "netAmountValueAfterDiscount value: ",
      netAmountValueAfterDiscount
    );
    if (
      (totalInvAmtDisountDetails.discountType === "flat" &&
        netAmountValueAfterDiscount >= parseFloat(0.0)) ||
      (totalInvAmtDisountDetails.discountType === "percentage" &&
        event.target.value <= 100)
    ) {
      let discountedValue = event.target.value === "" ? 0.0 : parseFloat(event.target.value);
      let data = {
        discountType: totalInvAmtDisountDetails.discountType,
        discountValue: discountedValue,
      };
      console.log(
        "TotalInvAmtDisountDetails value: ",
        totalInvAmtDisountDetails
      );
      setTotalInvAmtDisountDetails(data);
    }
  };

  // The factorial will only be re-calculated when 'number' changes.
  const invoiceCalculationResp = useMemo(
    () => invoiceCalculation(rowData, totalInvAmtDisountDetails),
    [rowData, updateInvoiceCal, totalInvAmtDisountDetails]
  );

  const handleCellEdit = (params) => {
    const updatedRow = params.data;
    const column = params.colDef.field;
    const newValue = params.newValue;
    const oldValue = params.oldValue;
    console.log("handleCellEdit: ", params);

    if (newValue !== oldValue) {
      console.log("Edited field:", column);
      console.log("Old value:", oldValue);
      console.log("New value:", newValue);
      console.log("Updated row:", updatedRow);
    }
  };

  // if (loading) {
  //     // return <div className="d-flex justify-content-center align-items-center">Loading...</div>;
  //     return (
  //       <div className="d-flex justify-content-center align-items-center h-100 m-3">
  //         <Loading isBackgroundTransparent={isBackgroundTransparent} />
  //       </div>
  //     );
  //   }

  return (
    <>
      {/* <> */}
      <Dialog
        open={showViewInvoicePage}
        onClose={handleCloseViewInvoicePage}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Invoice Viewer"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {pdfData && (
              <iframe
                // ref={iframeRef}
                src={pdfData}
                width="100%"
                height="600px"
                style={{ border: "1px solid #ccc" }}
                title="PDF Viewer"
                // Optional: onLoaded could be used if you need to know when iframe content is loaded
                onLoad={() => console.log("Iframe content loaded.")}
              />
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseViewInvoicePage} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* </> */}
      {viewInvoiceDetails &&
        ERP_VISIT_FIN_SUMMARY_TYPE_INV === viewInvoiceDetails.type ? (
        <>
          {/* <div className="d-flex justify-content-between px-3">
            <div className="d-flex">
              <div className="fw-medium">Invoice Id :</div>{" "}
              <div>{viewInvoiceDetails.invoiceId} </div>
            </div>
            <div className="d-flex">
              <div className="fw-medium">Date :</div>{" "}
              <div>{viewInvoiceDetails.invoiceDate}</div>
            </div>
            <div className="d-flex">
              <div className="fw-medium">Total Discount Amount : </div>{" "}
              <div>{viewInvoiceDetails.discountAmt}</div>
            </div>
            <div className="d-flex">
              <div className="fw-medium">Total Bill Amount : </div>{" "}
              <div>{viewInvoiceDetails.billAmt}</div>
            </div>
          </div>
          <div className="d-flex justify-content-start px-3">
          {(viewInvoiceDetails.taxAmount && viewInvoiceDetails.taxAmount.length>1) && (
                <>
                  <div className="d-flex me-3">
                    <div className="fw-medium">Tax :</div>{" "}
                    <div>{viewInvoiceDetails.taxAmount} </div>
                  </div>
                </>
            )}
            <div className="d-flex ms-2">
              <div className="fw-medium">Remarks :</div>{" "}
              <div>{viewInvoiceDetails.remarks} </div>
            </div>
          </div> */}
          <div className="d-flex flex-wrap align-items-start invoiceTitle ms-2 mt-2">
            {/* Invoice ID */}
            <div
              className="me-4 mb-2 flex-fill flex-lg-grow-0"
              style={{ minWidth: "100px" }}
            >
              <h6 className="mb-1">Invoice ID</h6>
              <span className="text-muted">{viewInvoiceDetails.invoiceId}</span>
            </div>

            {/* Date */}
            <div
              className="me-4 mb-2 flex-fill flex-lg-grow-0"
              style={{ minWidth: "100px" }}
            >
              <h6 className="mb-1">Date</h6>
              <span className="text-muted">
                {viewInvoiceDetails.invoiceDate}
              </span>
            </div>

            {/* Total Discount */}
            <div
              className="me-4 mb-2 flex-fill flex-lg-grow-0"
              style={{ minWidth: "180px" }}
            >
              <h6 className="mb-1">Total Discount Amount</h6>
              <span className="text-muted">
                {viewInvoiceDetails.discountAmt}
              </span>
            </div>

            {/* Tax */}
            {viewInvoiceDetails.taxAmount &&
              viewInvoiceDetails.location ===
              BILLING_LOCATION_NAMES.PHARMACY &&
              (!viewInvoiceDetails.patientERPObj ||
                viewInvoiceDetails.patientERPObj.visitType ===
                PATIENT_VISIT_TYPE.OUTPATIENT) && (
                <div
                  className="me-4 mb-2 flex-fill flex-lg-grow-0"
                  style={{ minWidth: "100px" }}
                >
                  <h6 className="mb-1">Tax</h6>
                  <span className="text-muted">
                    ₹ {viewInvoiceDetails.taxAmount}
                  </span>
                </div>
              )}

            {/* Total Bill */}
            <div
              className="me-4 mb-2 flex-fill flex-lg-grow-0"
              style={{ minWidth: "180px" }}
            >
              <h6 className="mb-1">Total Bill Amount</h6>
              <span className="text-muted">{viewInvoiceDetails.billAmt}</span>
            </div>

            {/* Remarks */}
            {viewInvoiceDetails.remarks &&
              viewInvoiceDetails.remarks.trim().length > 0 && (
                <div
                  className="me-4 mb-2 flex-grow-1"
                  style={{ minWidth: "180px", maxWidth: "100%", overflow: "hidden" }}
                >
                  <h6 className="mb-1">Remarks</h6>
                  <div
                    className="remarks-det text-muted text-truncate"
                    title={viewInvoiceDetails.remarks}
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {viewInvoiceDetails.remarks}
                  </div>
                </div>
              )}
          </div>
          <div className="ms-1" style={containerStyle}>
            <div
              className="ag-theme-balham ag-style ag-header-left px-1 py-2 w-100"
              style={gridStyle}
            >
              <AgGridReact
                pagination={COMPONENT_WISE_AG_GRID_PAGINATION.ERPInvoice}
                paginationPageSize={
                  COMPONENT_WISE_AG_GRID_PAGINATION_SIZE.ERPInvoice
                }
                autoSizeStrategy={autoSizeStrategy}
                rowData={rowData}
                rowStyle={rowStyle}
                defaultColDef={defaultColDef}
                columnDefs={viewInvoiceColumnDefs}
                headerHeight={AG_GRID_REACT_HEADER_ROW_HEIGHT}
                getRowId={getRowId}
                // suppressHeaderKeyboardEvent={() => true} // disables all keyboard events on headers
                suppressHeaderFocus={true}
                frameworkComponents={{
                  ActionRenderer: ActionRenderer,
                }}
              />
            </div>
          </div>
          <div className="d-flex justify-content-end d-grid gap-3">
            {rowData && rowData.length > 0 && (
              <>
                <Button
                  className="p-2 my-2 bg-primary text-white"
                  variant="printInvoice"
                  onClick={(event) =>
                    printInvoice(
                      viewInvoiceDetails,
                      "preview",
                      HMS_REPORT_TEMPLATE_TYPE.SINGLE_INVOICE
                    )
                  }
                >
                  {ERP_LABEL_PREVIEW_INVOICE}
                </Button>
                <Button
                  className="p-2 my-2 bg-primary text-white"
                  variant="printInvoice"
                  onClick={(event) =>
                    printInvoicePDF(
                      viewInvoiceDetails,
                      "print",
                      HMS_REPORT_TEMPLATE_TYPE.SINGLE_INVOICE
                    )
                  }
                >
                  {ERP_LABEL_PRINT_INVOICE}
                </Button>
              </>
            )}
            <Button
              className="p-2 my-2 bg-danger text-white"
              variant="cancel"
              onClick={closeNewInvoice}
            >
              {ERP_LABEL_CLOSE}
            </Button>

            {printdata && triggerAction && (
              <HeaderFooterComponent
                title="Invoice"
                data={printdata}
                triggerAction={triggerAction}
                onComplete={() => {
                  setPrintData(""); // clear data
                  setTriggerAction(""); // clear action
                  console.log("Print action completed and state cleared.");
                }}
              />
            )}
          </div>
        </>
      ) : (
        <>
          {viewCard && (
            <div>
              <AddServiceCard
                addShow={viewCard}
                addNewService={rowInfo}
                setAddNewService={setRowInfo}
                serviceForm={serviceForm}
                setServiceForm={setServiceForm}
                doctorList={doctorList}
                handleAdd={handleAdd}
                handleCancelAdd={handleCancelAdd}
                isaddDisable={isaddDisable}
              />
            </div>
          )}
          <div className="ms-1" style={containerStyle}>
            <div
              className="ag-theme-balham ag-style ag-header-left px-1 py-2 w-100"
              style={gridStyle}
            >
              <AgGridReact
                reactNext={true}
                autoSizeStrategy={autoSizeStrategy}
                rowData={rowData}
                rowStyle={rowStyle}
                stopEditingWhenCellsLoseFocus={true}
                onCellDoubleClicked={(event) => {
                  console.log("on cell double clicked start: ", event);
                }}
                onCellEditingStopped={(event) => {
                  console.log("Editing stopped on:", event);
                  setUpdateInvoiceCal(!updateInvoiceCal);
                }}
                // onCellValueChanged={handleCellEdit}
                defaultColDef={defaultColDef}
                columnDefs={newInvoiceColumnDefs}
                headerHeight={AG_GRID_REACT_HEADER_ROW_HEIGHT}
                getRowId={getRowId}
                // suppressHeaderKeyboardEvent={() => true} // disables all keyboard events on headers
                suppressHeaderFocus={true}
                frameworkComponents={{
                  ActionRenderer: ActionRenderer,
                  NumericCellEditor: NumericCellEditor,
                }}
              />

              {/* Discount Input Section - Mimic Tailwind's bg-blue-50, rounded-lg, border border-blue-200, shadow-sm */}
              <Box
                sx={{
                  marginBottom: "1rem",
                  padding: "0.5rem",
                  backgroundColor: "#eff6ff",
                  borderRadius: "0.375rem",
                  border: "1px solid #bfdbfe",
                  boxShadow: "0 1px 1px rgba(0,0,0,0.03)",
                }}
              >
                <Typography
                  variant="div"
                  component="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#1e40af",
                    marginBottom: "1rem",
                    display: "flex",
                    alignItems: "center",
                  }} // text-xl font-bold text-blue-800 mb-4 flex items-center
                >
                  {" "}
                  ₹ Apply Invoice Discount
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 2,
                    mb: 2,
                  }}
                >
                  <Box>
                    <FormControl component="fieldset">
                      <RadioGroup
                        row
                        aria-label="discount-type"
                        name="discount-type-group"
                        value={totalInvAmtDisountDetails.discountType || ""}
                        onChange={(event) => handleDiscountTypeChange(event)}
                      >
                        <FormControlLabel
                          value="flat"
                          control={<Radio sx={{ color: "#2563eb" }} />} // text-blue-600
                          label={
                            <Typography
                              variant="div"
                              component="span"
                              sx={{
                                // fontSize: "1.125rem",
                                fontWeight: "500",
                                color: "#374151",
                              }}
                            >
                              Flat Discount
                            </Typography>
                          } // text-lg font-medium text-gray-700
                        />
                        <FormControlLabel
                          value="percentage"
                          control={<Radio sx={{ color: "#2563eb" }} />} // text-blue-600
                          label={
                            <Typography
                              variant="div"
                              component="span"
                              sx={{
                                // fontSize: "1.125rem",
                                fontWeight: "500",
                                color: "#374151",
                              }}
                            >
                              Percentage Discount
                            </Typography>
                          } // text-lg font-medium text-gray-700
                        />
                      </RadioGroup>
                    </FormControl>
                  </Box>
                  <Box sx={{ width: { xs: "100%", sm: 240 }, flexShrink: 0 }}>
                    <TextField
                      fullWidth
                      type="number"
                      value={totalInvAmtDisountDetails.discountValue}
                      onChange={(event) => handleDiscountValueChange(event)}
                      label={
                        totalInvAmtDisountDetails.discountType === "flat"
                          ? "Amount (₹)"
                          : "Percentage (%)"
                      }
                      // variant="outlined"
                      // fullWidth
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          // paddingLeft: "2.5rem", // pl-10
                          // paddingRight: "1rem", // pr-4
                          // paddingTop: "0.5rem", // py-2
                          // paddingBottom: "0.5rem", // py-2
                          borderRadius: "0.5rem", // rounded-lg
                          border: "1px solid #d1d5db", // border border-gray-300
                          boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", // shadow-sm
                          "&.Mui-focused fieldset": {
                            borderColor: "#3b82f6", // focus:border-blue-500
                            boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.5)", // focus:ring-blue-500
                          },
                          "& input": {
                            color: "#1f2937", // text-gray-900
                          },
                        },
                      }}
                      InputProps={{
                        startAdornment:
                          totalInvAmtDisountDetails.discountType === "flat" ? (
                            <InputAdornment position="start">
                              <CurrencyRupeeIcon sx={{ color: "#9ca3af" }} />
                            </InputAdornment>
                          ) : (
                            <InputAdornment position="start">
                              <PercentIcon sx={{ color: "#9ca3af" }} />
                            </InputAdornment>
                          ),
                        inputProps: {
                          inputMode: "numeric", // mobile keyboard numeric
                          pattern: "[0-9]*", // restrict pattern to digits only
                          min: 0,
                          step: "0.1",
                          max:
                            totalInvAmtDisountDetails.discountType === "flat"
                              ? invoiceCalculationResp.totalAfterDiscount
                              : 100,
                        },
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: { xs: "stretch", sm: "center" },
                    flexDirection: { xs: "column", sm: "row" },
                    gap: "1rem",
                    marginTop: "0.75rem",
                  }}
                >
                  <Typography
                    component="label"
                    sx={{
                      fontWeight: 500,
                      color: "#374151",
                      minWidth: "90px", // so label stays tight
                    }}
                  >
                    Remarks
                  </Typography>

                  <TextField
                    size="small"
                    placeholder="Enter remarks"
                    value={remarks || ""}
                    onChange={(e) => setRemarks(e.target.value)}
                    sx={{
                      flex: 1,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "0.5rem",
                        border: "1px solid #d1d5db",
                        boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                          boxShadow: "0 0 0 3px rgba(59,130,246,0.5)",
                        },
                      },
                    }}
                  />
                </Box>
              </Box>

              {/* Totals Display Section */}
              <div className="mt-4 p-3 bg-success bg-opacity-10 rounded border border-success-subtle shadow-sm text-end">
                <p className="fs-5 text-secondary mb-2">
                  <strong className="fw-semibold text-dark">Subtotal:</strong>{" "}
                  <span className="fw-bold text-success">
                    ₹ {invoiceCalculationResp.totalBeforeDiscount.toFixed(2)}
                  </span>
                </p>
                <p className="text-md text-gray-700 mb-2">
                  <strong className="fw-semibold text-dark">
                    Discount Applied:
                  </strong>{" "}
                  <span className="fw-bold text-danger">
                    ₹{" "}
                    {invoiceCalculationResp.calculatedDiscountAmount.toFixed(2)}
                  </span>
                </p>
                <p className="text-md text-gray-700 mb-2">
                  <strong className="fw-semibold text-dark">Round Off:</strong>{" "}
                  <span className="fw-bold text-dark">
                    ₹ {invoiceCalculationResp.roundOff.toFixed(2)}
                  </span>
                </p>
                <p className="fs-6 fw-bold text-dark border-top border-2 border-success mt-4 pt-4">
                  Total After Discount:{" "}
                  <span className="fw-bold" style={{ color: "#dc2626" }}>
                    ₹{" "}
                    {(
                      invoiceCalculationResp.totalAfterDiscountWithRoundOff
                    ).toFixed(2)}
                  </span>
                </p>
              </div>

              {/* Action Buttons Section */}
              <Box
                display="flex"
                justifyContent="flex-end"
                flexWrap="wrap"
                gap={2}
                mt={4}
              >
                {rowData && rowData.length > 0 && (
                  <>
                    <Button
                      variant="contained"
                      startIcon={<DescriptionRoundedIcon />}
                      onClick={generateInvoice}
                      sx={{
                        backgroundColor: "#4f46e5", // bg-indigo-600
                        color: "#ffffff",
                        fontWeight: "600",
                        borderRadius: "0.5rem",
                        boxShadow:
                          "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                        "&:hover": { backgroundColor: "#4338ca" }, // hover:bg-indigo-700
                        "&:focus": {
                          outline: "none",
                          boxShadow:
                            "0 0 0 3px rgba(99, 102, 241, 0.5), 0 0 0 6px rgba(255, 255, 255, 0.5)",
                        },
                      }}
                    >
                      {" "}
                      {ERP_LABEL_GENERATE_INVOICE}
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<CreditCard />}
                      onClick={showPaymentPage}
                      sx={{
                        backgroundColor: "#16a34a", // bg-green-600
                        color: "#ffffff",
                        fontWeight: "600",
                        borderRadius: "0.5rem",
                        boxShadow:
                          "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                        "&:hover": { backgroundColor: "#15803d" }, // hover:bg-green-700
                        "&:focus": {
                          outline: "none",
                          boxShadow:
                            "0 0 0 3px rgba(74, 222, 128, 0.5), 0 0 0 6px rgba(255, 255, 255, 0.5)",
                        },
                      }}
                    >
                      {ERP_LABEL_PAY_NOW}
                    </Button>
                  </>
                )}
                <Button
                  variant="contained"
                  startIcon={<Close />}
                  onClick={closeNewInvoice}
                  sx={{
                    backgroundColor: "#ef4444", // bg-red-500
                    color: "#ffffff",
                    fontWeight: "600",
                    borderRadius: "0.5rem",
                    boxShadow:
                      "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                    "&:hover": { backgroundColor: "#dc2626" }, // hover:bg-red-600
                    "&:focus": {
                      outline: "none",
                      boxShadow:
                        "0 0 0 3px rgba(239, 68, 68, 0.5), 0 0 0 6px rgba(255, 255, 255, 0.5)",
                    },
                  }}
                >
                  {ERP_LABEL_CANCEL}
                </Button>
              </Box>
            </div>
          </div>
          {/* <div className="d-flex justify-content-end d-grid gap-3">
            <Button
              className="p-2 my-2 bg-primary text-white"
              variant="generateInvoice"
              onClick={generateInvoice}
            >
              {ERP_LABEL_GENERATE_INVOICE}
            </Button>
            {rowData && rowData.length > 0 && (
              <Button
                className="p-2 my-2 bg-primary text-white"
                variant="PayNow"
                onClick={showPaymentPage}
              >
                {ERP_LABEL_PAY_NOW}
              </Button>
            )}
            <Button
              className="p-2 my-2 bg-danger text-white"
              variant="cancel"
              onClick={closeNewInvoice}
            >
              {ERP_LABEL_CANCEL}
            </Button>
          </div> */}

          <ConfirmDeleteDialog
            open={openConfirm}
            title="Delete Service"
            message="Are you sure you want to delete this service?"
            showReason={false}
            onCancel={() => setOpenConfirm(false)}
            onConfirm={async () => {
              if (pendingDelete) await pendingDelete();

              setOpenConfirm(false);
            }}
          />
        </>
      )}
    </>
  );
}
